import {Stack, Modal, Typography, Box, Button, IconButton, CircularProgress} from "@mui/material";
import {IconReload, IconX} from "@tabler/icons-react";
import {useEffect, useState} from "react";
import axios from "axios";
import {grey} from "@mui/material/colors";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: "xl", width: "90%",
  minHeight: "60dvh", maxHeight: "90dvh",
  bgcolor: 'background.paper',
  borderRadius: 2,
  border: '0px solid #000',
  boxShadow: 24,
  p: 3,
  overflowY: "auto"
};

export const ContainerLogsModal = ({open, handleClose, container, project}) => {
  const [logs, setLogs] = useState("");
  const [size, setSize] = useState(60);
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!project?.configuration?.health_check_api || !container?.id) {
      return;
    }
    setLogs("")
    setSize(60);
    fetchLogs().then(() => console.log("Fetch logs first time"))
    const subscribe = setInterval(() => {
      fetchLogs().then(() => console.log("Fetch logs"))
    }, 1000 * 30)

    return () => clearInterval(subscribe);
  }, [project?.configuration?.health_check_api, container]);

  const fetchLogs = async () => {
    if (!project?.configuration?.health_check_api) {
      return;
    }
    setLoading(true)

    const url = new URL(project?.configuration?.health_check_api || "");
    url.pathname = `/container/logs/${container?.id}`;
    try {
      const response = await axios.get(url.href);
      console.log("Fetched logs", response);
      setLogs(response?.data?.logs || "")
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      open={!!open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Stack direction={"column"} gap={1} sx={style}>
        <Stack direction={"row"} gap={1} justifyContent={"space-between"} alignItems={"center"}>
          <Typography fontWeight={700} fontSize={"1.05em"} gutterBottom>{container?.name}</Typography>
          <Box>
            <IconButton onClick={handleClose}><IconX /></IconButton>
          </Box>
        </Stack>
        <Stack direction={"column-reverse"} gap={0.5} sx={{flex: 1, overflowY: "auto", px: 2, py: 1, bgcolor: grey[100]}}>
          {
            logs?.split("\n")
              ?.reverse()
              ?.slice(0, size)
              ?.map((log, index) => <Typography key={index} variant={"body2"}>{log}</Typography>)
          }
          <Button disabled={loading} startIcon={loading ? <CircularProgress size={19} /> : <IconReload />} onClick={() => setSize(size + 60)}>Load More</Button>

        </Stack>
      </Stack>
    </Modal>
  )
}